import { render, staticRenderFns } from "./ChatItemLoteLista.vue?vue&type=template&id=bb8b41d4&scoped=true"
import script from "./ChatItemLoteLista.vue?vue&type=script&lang=js"
export * from "./ChatItemLoteLista.vue?vue&type=script&lang=js"
import style0 from "./ChatItemLoteLista.vue?vue&type=style&index=0&id=bb8b41d4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8b41d4",
  null
  
)

export default component.exports